<template>
  <div class="compound public-content">
    <div class="breadcrumb">背景管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0">编号:</span>
        <el-input v-model="searchElementVo.id" placeholder="请输入编号" clearable></el-input>
        <span style="margin:0 10px 0 20px">标签:</span>
        <el-select clearable v-model="searchElementVo.labelId" placeholder="请选择">
          <el-option label="" value="">全部</el-option>
          <el-option v-for="item in tageList" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <span style="margin:0 10px 0 20px">创建日期:</span>
        <el-date-picker clearable v-model="value1" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum == 1, onSubmit()">查询</el-button>
        <el-button round @click="batchHide" v-permission="'pts:admin:element:setShow'" type="primary">批量隐藏</el-button>
        <el-button round type="primary" v-permission="'pts:admin:element:add'" @click="$router.push({ path: '/uploadbackground', query: { elemType: 'BG' } })">上传 </el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="编号" prop="id"></el-table-column>
          <el-table-column label="缩略图">
            <template slot-scope="scope">
              <img style="max-width:100px" :src="scope.row.elementImage" alt="">
            </template>
          </el-table-column>
          <el-table-column label="素材标签" prop="label"></el-table-column>
          <el-table-column label="背景契合度" prop="label">
            <template slot-scope="scope">
              <span class="color-blue" @click="editFit.id = scope.row.id, editFit.fitId = scope.row.fitId, fitDialog = true">{{ scope.row.fit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建日期" prop="createdTime"></el-table-column>
          <el-table-column label="前端是否显示" prop="isShow" v-permission="'pts:admin:element:setShow'">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isShow" @change="val => setShow(val, scope.row)" :active-value='1' :inactive-value='0' active-color="rgb(20, 115, 230)" inactive-color="rgb(140, 140, 140)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <span class="color-blue" @click="updataFile(scope.row)">下载<br></span>
              <span class="color-blue" v-permission="'pts:admin:element:batchRemove'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 填充 -->
    <el-dialog :close-on-click-modal="false" title="背景契合度" :visible.sync="fitDialog" width="30%">
      <span>背景契合度:</span>
      <el-select v-model="editFit.fitId" placeholder="请选择">
        <el-option v-for="item in bgFitList" :key="item.id" :label="item.dictValue" :value="item.id"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fitDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该背景？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteComb(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { elementGetElementList, elementBgFit, elementUpdate, elementBatchRemove, labelGetLabelList, elementSetShow } from '@/api/pms'
export default {
  name: 'compound',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      editFit: {
        id: '',
        fitId: ''
      },
      fitDialog: false,
      value1: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      compoundType: [],
      tableData: [],
      searchElementVo: {
        createTimeBegin: '',
        createTimeEnd: '',
        elemType: 'BG',
        id: '',
        labelId: '',
        page: 1
      },
      searchLabelVo: {
        label: '',
        labelBelong: '',
        labelBelongCode: 'BG',
        page: 0
      },
      tageList: [],
      multipleSelection: [],
      bgFitList: []
    }
  },
  created () {
    this.onSubmit()
    this.getTaglist()
    this.getBgFit()
  },
  watch: {
    value1 (val) {
      this.searchElementVo.createTimeBegin = val === null ? '' : val[0]
      this.searchElementVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  methods: {
    async updataFile (row) {
      await this.getUrlBase64(row.elementImage).then(res => {
        console.log('res', res)
        if (res) {
          // 这里就按照chrome等新版浏览器来处理
          const a = document.createElement('a')
          a.href = res
          a.setAttribute('download', row.id)
          a.click()
        }
      })
    },
    getUrlBase64 (url, id) {
      console.log('url', url)
      return new Promise((resolve, reject) => {
        let image = new Image()
        // CORS 策略，会存在跨域问题https://stackoverflow.com/questions/20424279/canvas-todataurl-securityerror
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = this.naturalWidth
          canvas.height = this.naturalHeight
          // 将图片插入画布并开始绘制
          canvas.getContext('2d').drawImage(image, 0, 0)
          // result
          let result = canvas.toDataURL('image/png')
          resolve(result)
        }
        // image.setAttribute('crossOrigin', 'anonymous')
        image.src = url
        image.src = `${url}?${Date.now()}`
        image.crossOrigin = 'Anonymous'
        console.log('image', image)
        // 图片加载失败的错误处理
        image.onerror = () => {
          reject(new Error('图片流异常'))
        }
      })
    },
    saveEdit () {
      elementUpdate(this.editFit).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.onSubmit()
          this.fitDialog = false
        }
      })
    },
    // 获取背景默认项
    getBgFit () {
      elementBgFit().then(res => {
        if (res.data.success) {
          this.bgFitList = res.data.data
        }
      })
    },
    deleteComb (id) {
      elementBatchRemove([id]).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    setShow (val, row) {
      elementSetShow({ idList: [row.id], isShow: val }).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功')
        }
      })
    },
    batchHide () {
      let idList = []
      this.multipleSelection.forEach(item => {
        idList.push(item.id)
      })
      elementSetShow({ idList, isShow: 0 }).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功')
          this.onSubmit()
        }
      })
    },
    // 获取标签
    getTaglist () {
      labelGetLabelList({ pageNum: 1, pageSize: 10, searchLabelVo: this.searchLabelVo }).then(res => {
        if (res.data.success) {
          this.tageList = res.data.data.records
        }
      })
    },
    onSubmit () {
      elementGetElementList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchElementVo: this.searchElementVo }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records.sort((a, b) => b.id - a.id)
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    }
  }
}
</script>
 <style scoped lang="less">
 .compound {
   .add-category {
     justify-content: space-between;
   }
 
   .keywords {
     display: flex;
     justify-content: space-around;
     align-items: center;
 
     .el-input {
       width: 180px;
     }
   }
 }
 </style>
